module.exports = __webpack_public_path__ + "static/media/call.ed5b98bb.svg";